module.exports = __webpack_public_path__ + "static/img/8.fcd1d63e.png";